export default "__VITE_ASSET__11fd30ad__"